import Cookies from 'js-cookie'

const TOKEN_KEY = 'jwt_token'
const JWT_KEY = 'jwt'

export type StoredJWT = {
  userId?: number
  clientId?: number
  clientIds?: number[]
  issuer?: string
  permissions?: string
  iat?: number
  exp?: number
}

function setPersistentValue(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    // no-op
  }
}

function getPersistentValue(key: string): string | undefined {
  try {
    const value = localStorage.getItem(key)
    return value || undefined
  } catch {
    return undefined
  }
}

function removePersistentValue(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    // no-op
  }
}

function cookieExpiry(jwt?: StoredJWT): Date {
  const expMs = (jwt?.exp || 0) * 1000
  if (expMs > Date.now()) {
    return new Date(expMs)
  }
  return new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
}

export function setAuthToken(token: string, jwt?: StoredJWT): void {
  setPersistentValue(TOKEN_KEY, token)
  Cookies.set(TOKEN_KEY, token, {
    path: '/',
    expires: cookieExpiry(jwt),
  })
}

export function getAuthToken(): string | undefined {
  return getPersistentValue(TOKEN_KEY) || Cookies.get(TOKEN_KEY)
}

export function setStoredJWT(jwt: StoredJWT): void {
  const payload = JSON.stringify(jwt)
  setPersistentValue(JWT_KEY, payload)
  Cookies.set(JWT_KEY, payload, {
    path: '/',
    expires: cookieExpiry(jwt),
  })
}

export function getStoredJWT(): StoredJWT | undefined {
  const raw = getPersistentValue(JWT_KEY) || Cookies.get(JWT_KEY)
  if (!raw) return undefined
  try {
    return JSON.parse(raw) as StoredJWT
  } catch {
    return undefined
  }
}

export function clearAuthStorage(): void {
  removePersistentValue(TOKEN_KEY)
  removePersistentValue(JWT_KEY)
  Cookies.remove(TOKEN_KEY, { path: '/' })
  Cookies.remove(TOKEN_KEY, { path: '' })
  Cookies.remove(JWT_KEY, { path: '/' })
  Cookies.remove(JWT_KEY, { path: '' })
}
